import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

// 登录
export const login = (username, password) => {
  return api.post('/auth/login', { username, password })
}

export default api